<template>
  <b-dropdown
    ref="dropdown"
    :right="right"
    :variant="variant"
    :size="size"
    :class="dropdownClass"
    :toggle-class="toggleClass"
    :no-caret="noCaret"
    @hide="onMainHide"
    @hidden="$emit('hidden')"
  >
    <template #button-content>
      <slot name="toggle" />
    </template>
    <slot name="header" />
    <slot />
  </b-dropdown>
</template>

<script>
export default {
  name: 'NestedDropdown',
  provide() {
    return {
      nestedDropdown: this,
    }
  },
  props: {
    right: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    size: {
      type: String,
      default: null,
    },
    dropdownClass: {
      type: String,
      default: '',
    },
    toggleClass: {
      type: String,
      default: '',
    },
    noCaret: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      submenus: [],
      activeSubmenu: null,
      switchingSubmenu: false,
      shouldCloseMainOnSubmenuHide: false,
      forceClosing: false,
    }
  },
  mounted() {
    document.addEventListener('mousedown', this.handleDocumentPointerDown, true)
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleDocumentPointerDown, true)
  },
  methods: {
    /**
     * @returns {boolean} true jika ada submenu yang sedang terbuka
     */
    hasOpenSubmenu() {
      return this.submenus.some(s => {
        const { dropdown } = s.$refs
        return s.isShowing || (dropdown && dropdown.visible)
      })
    },
    handleDocumentPointerDown(event) {
      this.shouldCloseMainOnSubmenuHide = false
      if (!this.hasOpenSubmenu()) return

      const mainEl = this.$refs.dropdown?.$el
      if (!mainEl || !(event.target instanceof Node)) return

      if (!mainEl.contains(event.target)) {
        this.shouldCloseMainOnSubmenuHide = true
      }
    },
    /** Tutup dropdown utama */
    closeMainDropdown() {
      const { dropdown } = this.$refs
      if (dropdown && dropdown.visible) {
        dropdown.hide()
      }
    },
    /** Tutup dropdown utama dan semua submenu */
    close() {
      this.forceClosing = true
      this.submenus.forEach(s => s.close())
      this.closeMainDropdown()
      this.$nextTick(() => {
        this.forceClosing = false
      })
    },
    /**
     * Daftarkan submenu child (dipanggil saat mounted)
     * @param {import('vue').default} submenu
     */
    registerSubmenu(submenu) {
      if (!this.submenus.includes(submenu)) {
        this.submenus.push(submenu)
      }
    },
    unregisterSubmenu(submenu) {
      this.submenus = this.submenus.filter(s => s !== submenu)
      if (this.activeSubmenu === submenu) {
        this.activeSubmenu = null
      }
    },
    /**
     * Aktifkan satu submenu dan tutup submenu lain
     * @param {import('vue').default} submenu
     */
    setActiveSubmenu(submenu) {
      this.switchingSubmenu = true
      this.submenus.forEach(s => {
        if (s !== submenu && s.isShowing) {
          s.close()
        }
      })
      this.activeSubmenu = submenu
      this.$emit('submenu-active', submenu)
      this.$nextTick(() => {
        this.switchingSubmenu = false
      })
    },
    onSubmenuHide(submenu) {
      if (this.activeSubmenu === submenu) {
        this.activeSubmenu = null
      }
      if (this.shouldCloseMainOnSubmenuHide && !this.switchingSubmenu) {
        this.shouldCloseMainOnSubmenuHide = false
        this.$nextTick(() => {
          this.closeMainDropdown()
        })
      }
    },
    onMainHide(bvEvent) {
      if (this.forceClosing) return
      if (this.hasOpenSubmenu()) {
        bvEvent.preventDefault()
      }
    },
  },
}
</script>
